import React from 'react';
import { Spinner } from 'react-magma-dom';

import { Modal } from './Modal';

interface ILoadingModal {
  headerText: string;
  color: string;
}

export const LoadingModal: React.FC<ILoadingModal> = (props): JSX.Element => {
  const { headerText, color } = props;

  return (
    <Modal headerText={headerText}>
      <Spinner testId={'spinner'} color={color} size={50} />
    </Modal>
  );
};
